import React from "react";
import { MDBCol, MDBRow } from "mdb-react-ui-kit";
import { shallow } from "zustand/shallow";
import styles from "../../../styles/userPage/userPage.module.scss";
import Input from "../../common/Input";
import { useStore } from "../../../store";
import { IUser } from "../../../models/user";

const SocialMedia = () => {
    const { usernameInstagram, usernameTwitter, usernameFacebook } = useStore(
        state => ({
            usernameInstagram: state.userState.userDetail.usernameInstagram,
            usernameTwitter: state.userState.userDetail.usernameTwitter,
            usernameFacebook: state.userState.userDetail.usernameFacebook,
        }),
        shallow
    );

    const dispatch = useStore(state => state.dispatchUser);

    const onChange = (e: {
        stopPropagation: () => void;
        preventDefault: () => void;
        target: {
            name: keyof IUser;
            value: unknown;
        };
    }) => {
        e.stopPropagation();
        e.preventDefault();

        const { name, value } = e.target;

        dispatch({
            type: "UPDATE_USER_DETAIL",
            payload: { [name]: value },
        });
    };
    return (
        <div className="mt-5">
            <p className={styles.title}>Social Media</p>

            <MDBRow>
                <MDBCol size={12} xl={5} className="my-2 ">
                    <Input
                        type="text"
                        label="INSTAGRAM"
                        name="usernameInstagram"
                        id="usernameInstagram"
                        value={usernameInstagram}
                        placeholder="@instagram username"
                        onChange={onChange as never}
                    />
                </MDBCol>

                <MDBCol size={12} xl={5} className="my-2 ">
                    <Input
                        type="text"
                        onChange={onChange as never}
                        label="TIKTOK"
                        name="usernameTwitter"
                        id="usernameTwitter"
                        placeholder="@TikTok username"
                        value={usernameTwitter}
                    />
                </MDBCol>
                <MDBRow>
                    <MDBCol size={12} xl={5} className="my-2 ">
                        <Input
                            type="text"
                            label="FACEBOOK"
                            name="usernameFacebook"
                            id="usernameFacebook"
                            value={usernameFacebook}
                            placeholder="@facebook username"
                            onChange={onChange as never}
                        />
                    </MDBCol>
                </MDBRow>
            </MDBRow>
        </div>
    );
};

export default SocialMedia;
